import e from "react";
import { Card as s } from "../Card/Card.js";
typeof window != "undefined" && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = "3.35.0");
const t = _ref => {
  let {
    spot: o,
    title: a,
    description: n,
    cta: i
  } = _ref;
  return e.createElement(s, {
    "data-ds-component": "DS-CardSuggestion",
    variant: "outlined",
    className: "olx-card-suggestion",
    tag: "section"
  }, e.createElement("div", {
    className: "olx-card-suggestion__content"
  }, o, e.createElement("div", {
    className: "olx-card-suggestion__info-action"
  }, e.createElement("div", {
    className: "olx-card-suggestion__info"
  }, a, n), i)));
};
t.displayName = "CardSuggestion";
export { t as CardSuggestion };